import {IRecursoMembro} from "@models/recurso/IRecursoMembro.ts";

export type FuncaoRecurso =
    | 'Solicitante'
    | 'Comprador'
    | 'Aprovador'
    | 'Gestor'
    | 'Diretor';

export interface IFuncaoRecurso {
    id: FuncaoRecurso;
    nome: FuncaoRecurso;
    recursoMembros: IRecursoMembro[];
}

export const getNivelPermissoes = (): FuncaoRecurso[] => {
    return [
        'Solicitante',
        'Comprador',
        'Aprovador',
        'Gestor',
        'Diretor'
    ];
}

export const NvPermVerecursoDisponivel: FuncaoRecurso[] = [
    'Aprovador',
    'Gestor',
    'Diretor'
]

export const FuncoesRecurso = {
    Solicitante: 'Solicitante',
    Comprador: 'Comprador',
    Aprovador: 'Aprovador',
    Gestor: 'Gestor',
    Diretor: 'Diretor',
    VisualizarecursoDisponivel: ['Gestor', 'Diretor'],
    SolicitaTransferencia: ['Gestor', 'Diretor'],
}